import axios from "axios";
import { DBSizeTableChecker } from "./databaseChecker.schema";

export async function CallGetSizeTableDatabase(params: { company: string }) {
    return axios.get<DBSizeTableChecker[]>('v1/check/size/table', {
        params
    });
}
